module.exports = __webpack_public_path__ + "img/lva.0e89c52f.svg";